import EquityHome from "./EquityHomePage/EquityHome"
import EquityAccount from "./EquityAccountPage/Account"
import EquityBenefits from "./EquityBenefits/EquityBenefits"
export default function Equity(){
    return (
        <main>
        <EquityHome/>
        <EquityAccount/>
        <EquityBenefits/>
        </main>
    )
}